import { createContext } from "react";

import { CarrierTimelineDto } from "models/dto/CarrierTimelineDto";
import { QueryGridResponse } from "models/QueryGridResponse";

type CarrierActivitiesContextType = {
  activities: CarrierTimelineDto[];
  reloadActivities: () => Promise<void>;
  isLoading: boolean;
  isReloading: boolean;
  getNextPage: () => Promise<
    QueryGridResponse<CarrierTimelineDto>[] | undefined
  >;
  totalActivities: number;
};

export const getDefaultCarrierActivities = () => ({
  totalActivities: 0,
  activities: [],
  isLoading: false,
  isReloading: false,
  getNextPage: () => Promise.resolve(undefined),
  reloadActivities: () => Promise.resolve(),
});

export const CarrierActivitiesContext =
  createContext<CarrierActivitiesContextType>(getDefaultCarrierActivities());
